/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { StatsMitmItem } from './StatsMitmItem';
import {
    StatsMitmItemFromJSON,
    StatsMitmItemFromJSONTyped,
    StatsMitmItemToJSON,
} from './StatsMitmItem';

/**
 * 
 * @export
 * @interface GetStatsMitm200Response
 */
export interface GetStatsMitm200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof GetStatsMitm200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof GetStatsMitm200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {Array<StatsMitmItem>}
     * @memberof GetStatsMitm200Response
     */
    result: Array<StatsMitmItem>;
}

/**
 * Check if a given object implements the GetStatsMitm200Response interface.
 */
export function instanceOfGetStatsMitm200Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "result" in value;

    return isInstance;
}

export function GetStatsMitm200ResponseFromJSON(json: any): GetStatsMitm200Response {
    return GetStatsMitm200ResponseFromJSONTyped(json, false);
}

export function GetStatsMitm200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatsMitm200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': ((json['result'] as Array<any>).map(StatsMitmItemFromJSON)),
    };
}

export function GetStatsMitm200ResponseToJSON(value?: GetStatsMitm200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': ((value.result as Array<any>).map(StatsMitmItemToJSON)),
    };
}

